const API_BASE_URL = process.env.REACT_APP_API_URL;

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    // Agregar token de autenticación si existe
    const token = localStorage.getItem('clientToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Productos
  async getProducts(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/publico/obtener_productos_shop`);
  }

  async getProduct(slug) {
    return this.request(`/publico/obtener_producto_slug/${slug}`);
  }


  // Categorías
  async getCategories() {
    return this.request('/publico/lista_categorias');
  }

  /*
  async getCart() {
    return this.request('/customer/cliente');
  }

  async addToCart(product) {
    return this.request('/customer', {
      method: 'POST',
      body: JSON.stringify(product),
    });
  }

  async updateCartItem(itemId, quantity) {
    return this.request(`/cart/items/${itemId}`, {
      method: 'PUT',
      body: JSON.stringify({ quantity }),
    });
  }

  async removeFromCart(itemId) {
    return this.request(`/customer/${itemId}`, {
      method: 'DELETE',
    });
  }
    */

  // Pedidos
  async createOrder(orderData) {
    return this.request('/orders', {
      method: 'POST',
      body: JSON.stringify(orderData),
    });
  }

  async getOrders() {
    return this.request('/orders');
  }

  async getOrder(id) {
    return this.request(`/orders/${id}`);
  }

  // Autenticación
  async loginClient(credentials) {
    return this.request('/login/tienda', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });
  }
  
  async registerClient(userData) {
    return this.request('/cliente', {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  }
  /*
  async logout() {
    return this.request('/auth/logout', {
      method: 'POST',
    });
  }*/
}

export default new ApiService();